// extracted by mini-css-extract-plugin
export default {"modalBody":"YI_Pb8z1VPCb6S2QQrZ0"};